import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div(({ theme }) => {
  const { color, type } = theme.new;

  return `
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    background-color: ${color.neutral[2]};
    color: ${color.neutral[8]};
    line-height: 1.5rem;
    font-weight: ${type.weight.bold};
    font-size: ${type.size[16]};
    padding: 0.8125rem;
    border-radius: 8px;
  `;
});

const ActiveDaysIndicator = styled.span(({ theme }) => {
  return `
    &.active {
      color: ${theme.new.color.brand[2].dark};
      font-weight: bold;
    }
  `;
});

interface TaskStatusProps {
  current: number;
  max: number;
}

const TaskStatus: FC<TaskStatusProps> = ({ current, max }) => {
  return (
    <Container>
      <ActiveDaysIndicator className={current > 0 ? 'active' : ''}>{current}</ActiveDaysIndicator>/{max}
    </Container>
  );
};

export default TaskStatus;
